/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-restricted-globals */
import { fechaHoraRango, formatDate } from './date';

export const parserReportesGeneral = ({
  _id,
  nombre,
  unidades,
  rangoMin,
  rangoMax,
  tipoReporte,
  fechaInicio,
  fechaFin,
  minimo,
  maximo,
  promedio,
  alertas,
  consumo,
  isConsumo
}) => ({
  key: _id,
  sensor: nombre,
  rango: `(${`${rangoMin?.$numberDecimal}, ${rangoMax?.$numberDecimal}`}) ${unidades}`,
  tipoReporte: tipoReporte?.nombre,
  fechaInicio,
  fechaFin,
  minimo: minimo === null ? '-' : minimo?.$numberDecimal,
  maximo: maximo === null ? '-' : maximo?.$numberDecimal,
  promedio: promedio === null ? '-' : promedio,
  consumo: isConsumo === true ? consumo : '-',
  alertas: alertas === null ? 0 : alertas,
});

export const parserReportesBloques = (
  {
    fechaInicio,
    fechaFin,
    minimo,
    maximo,
    promedio,
    alertas,
    consumo,
    isConsumo
  }
) => ({
  key: fechaInicio + fechaFin,
  fecha: fechaHoraRango(fechaInicio, fechaFin),
  minimo: minimo === null ? '-' : minimo?.$numberDecimal,
  maximo: maximo === null ? '-' : maximo?.$numberDecimal,
  promedio: promedio === null ? '-' : promedio,
  consumo: isConsumo === true ? consumo : '-',
  alertas: alertas === null ? 0 : alertas,
});

export const parserReportesAcumulado = ({
  fecha,
  objetivo,
  totalRango1,
  totalRango2,
  totalRango3,
  secundario,
  total,
  ryo,
}, periodo) => ({
  key: fecha,
  fecha: periodo === 'Diario' ? formatDate(fecha) : fecha,
  objetivo,
  totalRango1,
  totalRango2,
  totalRango3,
  secundario,
  total,
  ryo: `${ryo}%`,
});
